import React from 'react'
import Internship_c1 from './Internship_c1'
import Navbar from './Navbar'
import Footer from './Footer'
import { useEffect, useState } from 'react';
function Full_internship() {
    const [showScrollTop, setShowScrollTop] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        setShowScrollTop(window.scrollY > 200);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);
  
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  return (
    <div>
        <Navbar/><br></br><br></br><br></br>
        <Internship_c1/>
        <Footer/>

             {/* Floating WhatsApp Icon */}
      <a
        href="https://wa.me/9944897638"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

      {/* Scroll to Top Icon */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">
          <i className="fas fa-arrow-up"></i>
        </div>
      )}
    </div>
  )
}

export default Full_internship